import { styled } from 'styled-components';
import Logo from 'components/Logo';

const CalloutWrapper = styled.section`
  width: 100vw;
  padding: 120px 24px;
  display: flex;
  justify-content: center;
  background-color: #253270;
`;

const Callout = styled.div`
  background-color: #2e3a82;
  margin: auto;
  max-width: 760px;
  padding: 20px 20px 16px;
  border-radius: 22px;
`;

const Header = styled.h1`
  font-size: 21px;
  margin: 0;

  &::before {
    width: 100%;
    height: 1px;
    content: '';
    display: block;
    color: #3c4fac;
    background-color: #3c4fac;
    margin: 8px 0 16px;
  }
`;

const Link = styled.a`
  color: #9edbff;
  text-decoration: none;
  font-weight: 500;
`;

const Text = styled.p`
  color: #fff;
  opacity: 0.94;
  font-weight: 500;
  font-size: 14px;
`;

const List = styled.ul`
  color: #fff;
`;

/**
 * The component to display when a dashboard is not found
 *
 * @returns {JSX.Element} - the not found component
 */
export default function NotFound() {
  return (
    <CalloutWrapper>
      <Callout>
        <Logo />
        <Header>Dashboard Not Found</Header>
        <Text>
          We can&apos;t find that dashboard right now. Please double check the
          URL, or reach out to us for another link.
        </Text>
        <List>
          <Text as="li">
            Go to&nbsp;
            <Link href="https://app.urbanfootprint.com/">
              UrbanFootprint Analyst
            </Link>
          </Text>
          <Text as="li">
            Visit our&nbsp;
            <Link href="https://docs.urbanfootprint.com/">
              Resilience Insights help site
            </Link>
          </Text>
        </List>
      </Callout>
    </CalloutWrapper>
  );
}
